import { useQuery } from "@tanstack/react-query";

import { getPosClient } from "./api";

/**
 * Pulls the active membership's location timezone off the cached
 * profile (#142). When the active scope isn't a location (partner /
 * org), or the location row doesn't carry a timezone, returns
 * ``undefined`` so date formatters fall back to the browser tz.
 *
 * Usage:
 *
 *   const tz = useActiveTimezone();
 *   formatDateTime(order.created_at, tz);
 *
 * Reads from the same ``["profile"]`` query the rest of the app
 * already populates - no extra round-trip.
 */
export function useActiveTimezone(): string | undefined {
  const profile = useQuery({
    queryKey: ["profile"],
    queryFn: () => getPosClient().getProfile(),
  });
  return profile.data?.active_membership?.location?.timezone;
}
